export const getPriceQueryParams = (searchParams, key, value) =>{
    const hasValueInParam = searchParams.has(key);

    if(value && hasValueInParam){
     searchParams.set(key, value) 
    } else if (value) {
        searchParams.append(key, value)
    } else if (hasValueInParam) {
        searchParams.delete(key)
    }

    return searchParams;
};

export const calculateOrderCost = (distance, vehicle) => {
    let ratePerKm;

    // Define rates based on vehicle type
    if (vehicle === "Suzuki") {
        // ratePerKm = 125;
        ratePerKm = 0.2;
    } else if (vehicle === "Mazda") {
        // ratePerKm = 260;
        ratePerKm = 0.2;
    } else if (vehicle === "Shehzore") {
        ratePerKm = 0.2;
        // ratePerKm = 130;
    } 
    else {
        throw new Error("Invalid vehicle type");
    }

    const totalAmount = (distance * ratePerKm + 2).toFixed(2);
    //const totalAmount = (distance * ratePerKm + 50).toFixed(2);

    return {
        totalAmount,
        vehicle,
    };
};

